export interface PendingThirdPartyProfile {
  provider: string
  email?: string
  display_name?: string
  avatar_url?: string
  sub?: string
}

const PENDING_THIRD_PARTY_PROFILE_KEY = 'askjyotish.pending_third_party_profile'

export function setPendingThirdPartyProfile(profile: PendingThirdPartyProfile) {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.sessionStorage.setItem(PENDING_THIRD_PARTY_PROFILE_KEY, JSON.stringify(profile))
  } catch {
    // Best-effort only; login should still work even if storage is unavailable.
  }
}

export function consumePendingThirdPartyProfile(): PendingThirdPartyProfile | null {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const raw = window.sessionStorage.getItem(PENDING_THIRD_PARTY_PROFILE_KEY)
    if (!raw) {
      return null
    }

    window.sessionStorage.removeItem(PENDING_THIRD_PARTY_PROFILE_KEY)
    const parsed = JSON.parse(raw) as PendingThirdPartyProfile
    return parsed && typeof parsed.provider === 'string' ? parsed : null
  } catch {
    return null
  }
}
